export default __webpack_public_path__ + "static/media/pinehurst.c424494e.jpeg";